<form #form="ngForm">
  <spk-card meta="Manage User Widgets"  divider="true">
    <div class="row">
      <div class="col-md-4" >
        <div *ngFor="let widget of model;let i = index">
          <widget [model]="widget" [showSelect]="true"></widget>
        </div>
      </div>
    </div>
  </spk-card>
</form>
